export const BonusGameFinishedGridView = {
  size: 100,
  gap: 0,
  name: "BonusGameFinishedGridView",
  padding: {
    top: 5,
    bottom: 5,
    left: 5,
    right: 5,
    portrate: {
      top: 3,
      bottom: 3,
      left: 3,
      right: 3,
    },
  },
  main: [
    {
      name: "empty",
      size: 3,
    },
    {
      name: "leftgrid",
      size: 65,
      type: "PortrateGridController",
      config: {
        name: "leftgrid",
        size: 100,
        gap: 0,
        main: [
          {
            name: "empty",
            size: 17,
          },
          {
            name: "bonus_game_finished_wrapper",
            bounds: {
              width: 1144,
              height: 680,
            },
            size: 75,
          },
        ],
      },
    },
  ],
  landscape: [
    {
      name: "leftgrid-landscape",
      size: 65,
      type: "PortrateGridController",
      config: {
        name: "leftgrid-landscape-1",
        size: 100,
        gap: 0,
        align: "left",
        main: [
          {
            name: "empty",
            size: 19.5,
          },
          {
            name: "bonus_game_finished_wrapper",
            bounds: {
              width: 1144,
              height: 680,
            },
            size: 75,
          },
        ],
      },
    },
  ],
  portrate: [
    {
      name: "empty",
      size: 14,
    },
    {
      name: "bonus_game_finished_wrapper",
      bounds: {
        width: 1144,
        height: 680,
      },
      align: "top",
      size: 34,
    },
  ],
};
